import { performLogin, CognitoState } from 'react-cognito';
import { CREDENTIALS_REFRESH_BUFFER } from '../constants';
import { signAndFetch } from '../lib/aws/api';
import { loginStabilized } from '../lib/react';

export function invokeApi(fetchOptions) {
  return async function(dispatch, getState) {
    await loginStabilized(getState);
    await dispatch(refreshLoginIfNeeded());
    return signAndFetch(getState().cognito.creds, fetchOptions);
  };
}

export function fetch(url, options) {
  return function(dispatch, getState, context) {
    return context.fetch(url, options);
  };
}

export function refreshLoginIfNeeded() {
  return async function(dispatch, getState) {
    const cognito = getState().cognito;

    if (!cognito.user) {
      return;
    }
    if (!cognito.creds) {
      return;
    }
    if (!cognito.creds.expireTime) {
      return;
    }
    if (cognito.state !== CognitoState.LOGGED_IN) {
      return;
    }

    const expiresAt = Date.parse(cognito.creds.expireTime);
    if (expiresAt - CREDENTIALS_REFRESH_BUFFER < Date.now()) {
      const action = await performLogin(cognito.user, cognito.config);
      return dispatch(action);
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/api.js